<template>
  <div class="ai-float-wrapper" @click.stop v-show="!hidden">
    <div class="ai-float-btn" :class="{ 'is-open': visible }" @click.stop="togglePanel">
      <img src="@/assets/image/lsmy-ai-robot.png" alt="AI助手" class="ai-icon" />
    </div>
    <transition name="ai-panel-fade">
      <div v-show="visible" class="ai-panel" @click.stop>
        <iframe ref="aiIframe" :src="aiUrl" class="ai-iframe" @load="onIframeLoad" allow="local-network-access *" />
      </div>
    </transition>
  </div>
</template>

<script>
import { AI_URL } from '@/services/api'
import { apiHiddenAiUrl } from "@/services/module/ai-float";
import ScriptExecutor from './executor'

export default {
  name: 'AiFloat',
  data() {
    return {
      aiUrl: AI_URL,
      aiUrlOrigin: new URL(AI_URL).origin,
      visible: false,
      iframeLoaded: false,
      pendingMessage: null,
      hidden: true,
      hiddenUrls: null
    }
  },
  mounted() {
    window.addEventListener('message', this.handleMessage)
    this.$EventBus.$on('AI_CHAT', this.sendChatMessageToAI)
  },
  watch: {
    '$route.path'(path) {
      if (path) this.judgeHidden(path)
    },
    roles() {
      this.judgeHidden(this.$route.path)
    }
  },
  computed: {
    roles() {
      return this.$store.getters.roles || []
    }
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
    this.$EventBus.$off('AI_CHAT', this.sendChatMessageToAI)
  },
  methods: {
    togglePanel() {
      this.visible = !this.visible
    },
    async queryHiddenUrls() {
      const res = await apiHiddenAiUrl({ system: 'MOM' })
      this.hiddenUrls = res?.data || []
      this.judgeHidden(this.$route.path)
    },
    judgeHidden(path) {
      if (!this.isLogin()) {
        this.hiddenUrls = null;
        this.hidden = true;
        return;
      }

      if (this.hiddenUrls === null) {
        this.queryHiddenUrls()
        return;
      }

      const forceShow = this.hiddenUrls.some(item => item.startsWith('!') && path.startsWith(item.slice(1)))
      this.hidden = !forceShow && this.hiddenUrls.some(item => !item.startsWith('!') && path.startsWith(item))
    },
    isLogin () {
      // 有token不代表已登录，只有拉取到用户信息（roles 非空）才算真正登录
      return this.roles.length > 0
    },
    sendMessage(msg) {
      const iframe = this.$refs.aiIframe
      if (iframe && iframe.contentWindow) {
        console.log('发送至', this.aiUrlOrigin, msg)
        iframe.contentWindow.postMessage(msg, this.aiUrlOrigin)
        return true
      }
      return false
    },
    handleMessage(event) {
      if (event.data && event.data.system) {
        switch (event.data.system) {
          case 'AI':
            this.handleAIMessage(event)
            break
          default:
            break
        }
      }
    },
    handleAIMessage(event) {
      const { origin, data } = event
      if (origin !== this.aiUrlOrigin) return
      if (!data || data.system !== 'AI') return

      const sendToAI = (payload) => {
        this.sendMessage({
          system: 'MOM',
          type: data.type,
          requestId: data.requestId,
          payload: payload
        })
      }

      if (data.type === 'JAVASCRIPT') {
        this.handleJavascript(data, sendToAI)
      }
    },
    handleJavascript(data) {
      new ScriptExecutor(this).evalScript(data.script).then(payload => {
        this.sendMessage({
          system: 'MOM',
          type: data.type,
          requestId: data.requestId,
          payload: payload
        })
      })
    },
    onIframeLoad() {
      this.iframeLoaded = true
      if (this.pendingMessage) {
        this.sendMessage(this.pendingMessage)
        this.pendingMessage = null
      }
    },
    sendChatMessageToAI(payload) {
      const msg = {
        system: 'MOM',
        type: 'CHAT_MESSAGE',
        payload: payload
      }

      this.visible = true

      setTimeout(() => {
        if (!this.sendMessage(msg)) {
          this.pendingMessage = msg
        }
      }, 1500)
    }
  }
}
</script>

<style lang="less" scoped>
.ai-float-wrapper {
  position: fixed;
  right: 0;
  bottom: 10%;
  z-index: 9999;
}

.ai-float-btn {
  width: 90px;
  height: 90px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-right: -35px;

  &:hover {
    margin-right: -25px;
  }

  &.is-open {
    margin-right: -25px;
  }

  .ai-icon {
    width: 90px;
    height: 90px;
    transform: rotate(-45deg);
  }
}

.ai-panel {
  position: absolute;
  right: 70px;
  top: 0;
  transform: translateY(-85%);
  width: 700px;
  height: 800px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 6px 30px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.ai-iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: none;
}

.ai-panel-fade-enter-active,
.ai-panel-fade-leave-active {
  transition: all 0.3s ease;
}

.ai-panel-fade-enter,
.ai-panel-fade-leave-to {
  opacity: 0;
  transform: translateY(10px) scale(0.95);
}

@media print {
  .ai-float-wrapper {
    display: none !important;
  }
}
</style>
